import Customer from './views/Customer.vue'
import Contact from './views/Contact.vue'

const route = [
  {
    path: '/liste-client',
    name: 'customer',
    component: Customer,
    meta: {
      layout: 'light',
      auth: true,
      role: ['A','R']
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      layout: 'default',
      title: 'Contact',
      auth: true,
      menu: true,
      lang_code: 'contact_us',
      role: ['A','R','C','I'],
      customer_required: true,
      order: 10
    }
  }
]

export default route